import { addUserBlock, addUserBlockFile } from 'client/actions/blockActions'
import * as blockApi from 'client/api/blockApi'
import { PageLocaleEnum } from 'common/enums/PageLocaleEnum'
import { useActions } from 'common/hooks/useActions'
import { BaseEntityNewInterface } from 'src/shared/schemas/base-entity.schema'
import { EntityIdType } from 'src/shared/schemas/entity-id.schema'

interface CreateUserBlockParams {
  blockEntities: BaseEntityNewInterface[]
  entityId: EntityIdType
  files: File[]
  locale: PageLocaleEnum
  title: string
}

export const useCreateUserBlock = () => {
  const addBlock = useActions(addUserBlock)
  const addFile = useActions(addUserBlockFile)

  const createUserBlock = async ({
    blockEntities,
    entityId,
    files,
    locale,
    title,
  }: CreateUserBlockParams) => {
    const screenshotRes = await blockApi.screenshotCreate(
      blockEntities,
      entityId,
      files,
      locale,
    )

    const { data } = await blockApi.createUserBlock(
      blockEntities,
      screenshotRes.data,
      title,
    )

    addBlock(data.block)
    addFile(data.desktopPreview)
    return data
  }

  return {
    createUserBlock,
  }
}
